import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = () => ({
    rules: [],
    rule: {
        id: null,
        documentType: '',
        description: '',
        customer_id: null,
        createdAt: null,
        updatedAt: null,
    },
    createRuleLoading: false,
    updateRuleLoading: false,
    deleteRuleLoading: false,
    fetchRuleLoading: false,
    fetchRulesLoading: false,
});

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};